var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8,14.6l-3.7-3.7c0.9-1.1,1.4-2.6,1.4-4.1c0-3.8-3-6.7-6.7-6.7C3,0,0,3,0,6.7c0,3.8,3.1,6.7,6.7,6.7c1.6,0,3-0.5,4.1-1.4\n\tl3.8,3.8c0.3,0.3,0.7,0.3,0.9,0l0.3-0.3C16.1,15.2,16.1,14.8,15.8,14.6z M6.7,11.7c-2.7,0-5-2.2-5-5c0-2.7,2.2-5,5-5\n\tc2.7,0,5,2.2,5,5C11.7,9.5,9.5,11.7,6.7,11.7z"}));
}

Search.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Search;

Search.default = Search;
